export default {
  methods: {
    logoutAndRedirect(loginPath = '/login') {
      this.$http.post('/auth/logout').catch(error => {
        console.error('退出登录失败:', error);
      }).finally(() => {
        localStorage.removeItem('teacherInfo');
        localStorage.removeItem('token');
        localStorage.removeItem('sessionId');
        localStorage.removeItem('deviceType');
        window.location.href = loginPath;
      });
    }
  }
}
